import { render, staticRenderFns } from "./CaptureForm.vue?vue&type=template&id=3b847370&scoped=true"
import script from "./CaptureForm.vue?vue&type=script&lang=js"
export * from "./CaptureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b847370",
  null
  
)

export default component.exports